<div class="layout-wrapper " :class="containerClass">
    
    <!--header------------------------------------>
    <MenuBar :app_base_data="app_base_data" :menu_items="getMenus" ></MenuBar>
    <!--header------------------------------------>

    <!--sidebar----------------------------------->
    <div class="layout-sidebar">
        <app-sidebar-menu :app_base_data="app_base_data" :item_side_menu="item_side_menu" ></app-sidebar-menu>
    </div>
    <!--sidebar----------------------------------->

    <!--main-------------------------------------->
    <div class="layout-main-container">
        <div class="layout-main">
            <router-view></router-view>
        </div>
        <app-footer :app_base_data="app_base_data"></app-footer>
        <app-bottom-menu v-if="isMobile && getMenus.length > 0" :app_base_data="app_base_data" :menu_items="getMenus" ></app-bottom-menu>
    </div>
    <!--main-------------------------------------->
    <div class="layout-mask">
        
    </div>
</div>



